import { h } from 'vue'

// #region 对字符串中的 $url()  参数进行拆解
const paramsRreg = /(\$url\()((?!\$url\().)*(\)+)/g

/**
 * 将字符串中的 $url() 参数转换为 a标签
 * @param {*} content
 * @returns vNode
 */
export function stringUrlToVNode(content) {
  if (content && existParams(content)) {
    const { ss, vs } = splitParams(content)
    const hs = []
    ss.forEach((str, i) => {
      const v = vs[i]
      hs.push(h('lable', str))
      if (v) {
        hs.push(h('a', { href: v, target: '_blank' }, v))
      }
    })
    content = h('div', {}, hs)
    return content
  }
  return content
}

/**
 * 是否存在参数
 * @param {*} s
 * @returns
 */
export function existParams(s) {
  return paramsRreg.test(s)
}

/**
 * 字符串拆解
 * @param {*} s
 * @returns
 */
export function splitParams(s = '') {
  const ms = s.match(paramsRreg)
  const vs = []
  const res = []
  ms.forEach((v) => {
    v = v.substring(0, v.indexOf(')') + 1)

    res.push(v.replace(/^\$url\(/, '\\$url\\(').replace(/\)$/, '\\)'))
    v = v.replace(/^\$url\(/, '').replace(/\)$/, '')
    vs.push(v)
  })
  const ss = s.split(new RegExp(res.join('|')))
  if (ss[ss.length - 1] === '') {
    ss.splice(ss.length - 1, 1)
  }
  return {
    ss,
    vs
  }
}
// #endregion

/**
 * 存在http或https
 * @param {*} s
 * @returns
 */
export function existHttps(s) {
  return s.includes('https://') || s.includes('http://')
}

/**
 * 提取http链接
 * @param {String} s
 * @returns {Array}
 */
export function httpStrings(s = '') {
  const reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
  // var reg = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
  // var reg=/(http(s)?\:\/\/)?(www\.)?(\w+\:\d+)?(\/\w+)+\.(swf|gif|jpg|bmp|jpeg)/gi;
  // var reg=/(http(s)?\:\/\/)?(www\.)?(\w+\:\d+)?(\/\w+)+\.(swf|gif|jpg|bmp|jpeg)/gi;
  // let reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
  // var reg= /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/;
  // v = v.replace(reg, "<a href='$1$2'>$1$2</a>"); //这里的reg就是上面的正则表达式
  // s = s.replace(reg, "$1$2"); //这里的reg就是上面的正则表达式
  s = s.match(reg)
  return s
}

/**
 * 去掉http链接
 * @param {String} s
 * @returns
 */
export function removeHttps(s) {
  const reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
  return s.replace(reg, '')
}

// 首字母转大写
export function firstToUpper(str) {
  return str.replace(/( |^)[a-z]/g, (s) => s.toUpperCase())
}

// 首字母转小写
export function firstToLower(str) {
  return str.replace(/^./, (s) => s.toLowerCase())
}
